import { Client } from './client';

export class MapService {
  id: string;
  name: string;
  parcelLayer: string;
  endpointUrl: string;
  parcelLayerKeyField: string;
  client: Partial<Client>;
  clientID: string;
  mapKeyValue: string;

  constructor(options?: Partial<MapService>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class MapServiceListItem {
  id: string;
  name: string;
}
